import { Currency } from './currency';

export class NumberUtils {
  static padStart(value: number, maxSize: number, padValue: string): string {
    return ('' + value).padStart(maxSize, padValue);
  }

  static roundToUpTo2Decimals(val: number): string {
    return val.toFixed(2).replace('.', ',');
  }

  static roundToUpTo2DecimalsKeepWhole(val: number): string {
    return val % 1 === 0 ? val.toString() : val.toFixed(2).replace('.', ',');
  }

  static formatCurrency(
    value: number,
    currency: Currency,
    decimals: number = 2,
    keepWhole: boolean = false,
    attachSymbolDirectly: boolean = false,
  ): string {
    if (isNaN(value)) return '';

    let locale = 'de-DE';

    if (currency === Currency.USD) {
      locale = 'en-US';
    }

    const isWhole = value % 1 === 0;

    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: keepWhole && isWhole ? 0 : decimals,
      maximumFractionDigits: decimals,
    }).format(value);

    if (
      attachSymbolDirectly &&
      currency === Currency.EUR &&
      locale === 'de-DE'
    ) {
      return formatted.replace(/\s?€$/, '€');
    }

    return formatted;
  }
}
